
import "./banks.css";
import { Breadcrumb } from "../reusableUI/Breadcrumb";
import NumberFormat from "react-number-format";
import { useBank } from "../../hooks/useBank";
import { BankAccountDialogForm } from "./BankAccountDialogForm";
import { Link } from "react-router-dom";

import moment from "moment";
import { Plus } from "lucide-react";
import { Alert, LinearProgress } from '@mui/material';
import { BankNavigation } from './BankNavigation';
import { SummaryStat } from '../reusableUI/summary/SummaryStat';
import { summaryAmount } from '../../helpers/summaryFormatting';
import './bankLedger.css';

export const BankAccounts = () => {

  const {
    accounts,
    totals,
    formData,
    catalogs,
    openDialog,
    setOpenDialog,
    openCreate,
    openEdit,
    handleUpdateForm,
    saveForm,
    error, filters, handleFilters, refresh, loading, accountsLoading,
  } = useBank();

  return (
    <div className="p-container">
      {/* <h1 className='p-title'>Bancos</h1> */}

      {openDialog && (
        <BankAccountDialogForm
          formData={formData}
          title="Cuenta bancaria"
          openModal={openDialog}
          setModal={setOpenDialog}
          catalogs={catalogs}
          handleUpdateForm={handleUpdateForm}
          saveForm={saveForm}
          error={error}
          loading={loading}
        />
      )}

      <div>
        <Breadcrumb
          routes={[
            { id: 1, name: "Bancos", link: "/banks/tra", active: false },
            { id: 2, name: "Cuentas bancarias", link: "/banks", active: true },
          ]}
        />
      </div>

      <div className="flex justify-between items-center">
        <div>
          <button
            className="btn p-btn-primary flex items-center me-3"
            onClick={openCreate}
          >
            <Plus className="w-4" />
            <span>Cuenta</span>
          </button>
        </div>
      </div>

      <BankNavigation/>
      {error && <Alert severity="error" action={<button onClick={refresh}>Reintentar</button>}>{error}</Alert>}
      <div className="p-bank-stats">
        <SummaryStat label="Saldo registrado en soles" value={summaryAmount(error||accountsLoading?null:totals.saldo_actual_soles,{simbolo:'S/'})} context="Cuentas activas"/>
        <SummaryStat label="Saldo registrado en dólares" value={summaryAmount(error||accountsLoading?null:totals.saldo_actual_usd,{simbolo:'US$'})} context="Cuentas activas"/>
      </div>
      <div className="p-bank-filters"><label>Estado<select name="estado" value={filters.estado} onChange={handleFilters}><option value="true">Activas</option><option value="false">Inactivas</option><option value="">Todas</option></select></label></div>

      <div className="bg-white p-3 rounded-lg mt-3">
        {accountsLoading && <LinearProgress aria-label="Cargando cuentas"/>}
        <div className="table-responsive">
          <table className="table p-table-global">
            <thead className="p-thead-global">
              <tr className="text-center p-tr-titles-global">
                <th className="text-start">Banco</th>
                <th className="text-start">Cuenta</th>
                <th className="text-start">Descripción</th>
                <th className="text-center">Moneda</th>
                <th className="text-center">Saldo inicial</th>
                <th className="text-center">Saldo registrado</th>
                <th className="text-center">Fecha Inicio</th>
                <th className="text-center">Estado</th>
                <th>Movimientos</th>
              </tr>
            </thead>
            <tbody>
              {!accountsLoading && !error && accounts.map((item) => (
                <tr
                  className={`text-center p-tr-body-global ${item.estado === false ? "line-through" : ""}`}
                  key={item.id}
                >
                  <td className="text-start">
                    <Link
                      className="LinkTable"
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      {item.banco_nombre_corto}
                    </Link>
                  </td>
                  <td className="text-start">
                    <Link
                      className="LinkTable"
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      <span className="capitalize">{item.cuenta_nombre}</span> -
                      <span className="ms-1">{item.numero}</span>
                    </Link>
                  </td>
                  <td className="text-start">
                    <button type="button" className="p-bank-row-button" onClick={() => openEdit(item)}>
                      {item.nombre || '—'}
                    </button>
                  </td>
                  <td>
                    <Link
                      className="LinkTable"
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      {item.moneda}
                    </Link>
                  </td>
                  <td>
                    <Link
                      className="LinkTable"
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      <NumberFormat
                        value={
                          item.saldo_inicial
                            ? parseFloat(item.saldo_inicial)
                            : 0
                        }
                        displayType={"text"}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        decimalScale={2}
                        prefix={`${item.simbolo} `}
                        fixedDecimalScale
                      />
                    </Link>
                  </td>
                  <td>
                    <Link
                      className="LinkTable "
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      <NumberFormat
                        value={
                          item.saldo_actual ? parseFloat(item.saldo_actual) : 0
                        }
                        displayType={"text"}
                        thousandSeparator={item.separacion_miles}
                        decimalSeparator={item.separacion_decimales}
                        decimalScale={2}
                        prefix={`${item.simbolo} `}
                        fixedDecimalScale
                      />
                    </Link>
                  </td>
                  <td>
                    <Link
                      className="LinkTable"
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      {item?.fecha_inicio_control
                        ? moment(item?.fecha_inicio_control).format(
                            "DD-MM-YYYY",
                          )
                        : "Sin control de saldo"}
                    </Link>
                  </td>
                  <td>
                    <Link
                      className="LinkTable"
                      to="#"
                      onClick={() => openEdit(item)}
                    >
                      {item.estado === true ? "Activa" : "Desactivada"}
                    </Link>
                  </td>
                  <td><Link className="p-bank-row-button" to={`/banks/tra?account=${item.id}&currency=${item.id_moneda}`}>Ver movimientos</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
